module.exports = __webpack_public_path__ + "img/PS.34fc2ecb.svg";